import { Popup } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import moment from 'moment';
import { memo, useCallback, useState } from 'react';
import { CreateConversionQuote } from 'shared/data/wallets/v1';

import { ConfirmConvertCurrencyPopupContent } from '../ConfirmConvertCurrencyPopupContent/ConfirmConvertCurrencyPopupContent';
import { ConvertCurrencyPopupContent } from '../ConvertCurrencyPopupContent/ConvertCurrencyPopupContent';
import { convertCurrencyPopupState } from './ConvertCurrencyPopup.states';

export const ConvertCurrencyPopup = memo(() => {
    const [popupState, setPopupState] = useAtom(convertCurrencyPopupState);

    const [submittedQuote, setSubmittedQuote] = useState<CreateConversionQuote['response'] | null>(null);
    const [submittedQuoteDate, setSubmittedQuoteDate] = useState<string | null>(null);

    const handleTogglePopup = useCallback(
        (open: boolean) => {
            setPopupState((current) => ({
                ...current,
                isOpen: open,
            }));

            if (!open) {
                setSubmittedQuote(null);
            }
        },
        [setPopupState]
    );

    const handleQuoteSubmit = useCallback(
        (quote: CreateConversionQuote['response']) => {
            setSubmittedQuote(quote);
            setSubmittedQuoteDate(moment().format('DD MMM YYYY HH:mm'));
        },
        [setSubmittedQuote]
    );

    const resetSubmittedQuote = useCallback(() => {
        setSubmittedQuote(null);
        setSubmittedQuoteDate(null);
    }, []);

    return (
        <Popup open={popupState.isOpen} size='small' onToggle={handleTogglePopup}>
            {submittedQuote ? (
                <ConfirmConvertCurrencyPopupContent
                    quote={submittedQuote}
                    quoteDate={submittedQuoteDate}
                    onBack={resetSubmittedQuote}
                />
            ) : (
                <ConvertCurrencyPopupContent onSubmit={handleQuoteSubmit} />
            )}
        </Popup>
    );
});

ConvertCurrencyPopup.displayName = 'ConvertCurrencyPopup';
